import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "@modules/auth";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    const isAuth = this.authService.isAuth;

    if (currentUser && isAuth) {
      return true;
    }

    console.warn("[AuthGuard] User not authenticated, redirecting to login");
    this.router.navigate(["/auth/login"], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
